// 数字增加逗号
function addDou(num) {
     num = num.toString()
     var numArr = num.split('.')
     num = numArr[0]
     var result = ''
     while(num.length>3){
         result = ','+num.slice(-3)+result
         num = num.slice(0,num.length-3)
     }
     if(num){
         result = num+result
     }
     if (numArr[1]) {
      result = result+'.'+numArr[1]
     }
     
     return result
 }

 export default {
  addDou
 }


// WEBPACK FOOTER //
// ./src/common/filters.js